/**
 * Validates that the string adheres to the email format.
 * @param {String} email takes a string value of an email
 * @returns Boolean whether the string is formatted correctly.
 */
export const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
};
